import { useContext } from 'react';

import { TenantCtx, type TenantContext } from './tenant-context';

export function useTenant(): TenantContext {
  const ctx = useContext(TenantCtx);
  if (!ctx) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return ctx;
}
